import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4307783d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-300px mb-10 mb-lg-0 report-list-container" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = {
  key: 0,
  class: "align-middle"
}
const _hoisted_9 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_10 = {
  key: 2,
  class: "report-list"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "flex-lg-row-fluid ms-lg-7 ms-xl-10" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "card-title" }
const _hoisted_17 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_20 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "id", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "fw-semibold"
}
const _hoisted_25 = {
  key: 0,
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#4ed06e"}
}
const _hoisted_26 = {
  key: 1,
  class: "fa-solid fa-xmark fa-xl",
  style: {"color":"#d92626"}
}
const _hoisted_27 = {
  key: 0,
  class: "fa-solid fa-check fa-xl",
  style: {"color":"#4ed06e"}
}
const _hoisted_28 = {
  key: 1,
  class: "fa-solid fa-xmark fa-xl",
  style: {"color":"#d92626"}
}
const _hoisted_29 = { style: {"color":"rgb(124, 143, 162)"} }
const _hoisted_30 = { class: "me-3" }

import { onMounted, ref, computed } from "vue";
import ReportService from "@/projects/tenant/modules/report/services/ReportService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import NoDataCentralBox from "@/components/NoDataCentralBox.vue";
import TimeShow from "@/components/TimeShow.vue";
import { getImageUrl } from "@/core/plugins/ProcessImageLink";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import SalesRebateExportModal from "../modal/SalesReportExportModal.vue";
import IbRebateExportModal from "../modal/IbReportExportModal.vue";
import CreateTypes from "./CreateTypes.vue";
import CreateReport from "./CreateReport.vue";
import { Download } from "@element-plus/icons-vue";
import { getTenancy, tenancies } from "@/core/types/TenantTypes";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'bviReportIndex',
  setup(__props) {

const title = ref("");
const salesReportExportModalRef = ref<any>(null);
const ibReportExportModalRef = ref<any>(null);
const createTypesRef = ref<any>(null);
const createReportRef = ref<any>(null);
const reports = ref<Array<any>>([]);
const reportTypes = ref<Array<any>>([]);
const reportType = ref(<any>null);
const isLoadingTypes = ref(false);
const isLoading = ref(false);
const downloading = ref(false);
const groups = ref([]);
const partyId = ref(null);
const criteria = ref({
  page: 1,
  size: 10,
  type: null,
});
const idSelected = ref(null);
const selectBackground = (id) => {
  idSelected.value = id;
};

const fetchTypes = async () => {
  isLoadingTypes.value = true;
  try {
    const res = await ReportService.queryReqortTypes();
    reportTypes.value = res.data;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoadingTypes.value = false;
  }
};

const fetchGroups = async () => {
  isLoadingTypes.value = true;
  try {
    const res = await ReportService.queryGroups();
    groups.value = res;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoadingTypes.value = false;
  }
};

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  if (reportType.value) {
    criteria.value.type = reportType.value.id;
  } else {
    return false;
  }
  isLoading.value = true;
  try {
    const res = await ReportService.queryRequests(criteria.value);
    reports.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const fetchUserData = async () => {
  const store = useStore();
  const user = computed(() => store.state.AuthModule?.user);
  isLoading.value = false;
  try {
    const res = await ReportService.getUserDataByUid(user.value.uid);
    partyId.value = res.partyId;
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

const processQuery = (_query) => {
  var query = JSON.parse(_query);
  return query;
};

const downloadReportFile = async (_item) => {
  downloading.value = true;
  const downloadUrl = getImageUrl(_item.fileName);
  try {
    await TenantGlobalService.downloadFileByLink(downloadUrl, _item.fileName);
  } catch (error) {
    MsgPrompt.error(error);
  }
  downloading.value = false;
};

const showReports = async (type: any) => {
  reportType.value = type;
  title.value = " (" + type.title + ")";
  await fetchData(1);
};

const showSalesReportExportModal = () => {
  salesReportExportModalRef.value.show();
};

const showIbReportExportModal = () => {
  ibReportExportModalRef.value.show();
};

const showCreateTypes = () => {
  createTypesRef.value.show();
};

const showCreateReport = () => {
  createReportRef.value.show(reportType.value, groups.value);
};

onMounted(async () => {
  await fetchUserData();
  await fetchTypes();
  if (getTenancy.value == tenancies.jp) {
    await fetchGroups();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("title.reportTypes")), 1),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.$can('SuperAdmin'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "warning",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateTypes())),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create (Super) ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (isLoadingTypes.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(LoadingCentralBox)
                ]))
              : (!isLoadingTypes.value && reportTypes.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(NoDataCentralBox)
                  ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportTypes.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: _normalizeClass({
                'selected-background': item.id === idSelected.value,
              }),
                        onClick: ($event: any) => (selectBackground(item.id))
                      }, [
                        _createVNode(_component_FileIcon, {
                          type: item.type
                        }, null, 8, ["type"]),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (showReports(item)), ["prevent"])
                        }, _toDisplayString(item.title), 9, _hoisted_12)
                      ], 10, _hoisted_11))
                    }), 128))
                  ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("title.reportRequests")) + " " + _toDisplayString(title.value), 1),
            (reportType.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_el_button, {
                    type: "success",
                    plain: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
                    ]),
                    _: 1
                  }),
                  (reportType.value.key == 'SalesReportForTenant')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "success",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (showSalesReportExportModal()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (reportType.value.key == 'IbReportForTenant')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "success",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (showIbReportExportModal()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                reportType.value.key != 'SalesReportForTenant' &&
                reportType.value.key != 'IbReportForTenant'
              )
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "success",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (showCreateReport()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("table", _hoisted_19, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.hasData")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.valid")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.action")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.viewQuery")), 1)
                ])
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                    _createVNode(_component_LoadingRing)
                  ]))
                : (!isLoading.value && reports.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                      _createVNode(_component_NoDataBox)
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass({
                  'tr-select': item.partyId === partyId.value,
                })
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.id), 1),
                          _createElementVNode("td", null, _toDisplayString(item.name), 1),
                          _createElementVNode("td", null, [
                            _createVNode(TimeShow, {
                              "date-iso-string": item.createdOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          _createElementVNode("td", null, [
                            (!item.isEmpty)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                              : (_openBlock(), _createElementBlock("i", _hoisted_26))
                          ]),
                          _createElementVNode("td", null, [
                            (!item.isExpired)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                              : (_openBlock(), _createElementBlock("i", _hoisted_28))
                          ]),
                          _createElementVNode("td", _hoisted_29, [
                            (item.isExpired)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("status.failed")), 1)
                                ], 64))
                              : (item.isGenerated)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("status.readyForDownload")), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("status.processing")) + " ... ", 1)
                                  ], 64))
                          ]),
                          _createElementVNode("td", null, [
                            (item.isGenerated)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  icon: _unref(Download),
                                  circle: "",
                                  onClick: ($event: any) => (downloadReportFile(item)),
                                  disabled: downloading.value
                                }, null, 8, ["icon", "onClick", "disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processQuery(item.query), (value, index) => {
                              return (_openBlock(), _createElementBlock("span", { key: index }, [
                                _createElementVNode("span", _hoisted_30, _toDisplayString(index) + ": " + _toDisplayString(value), 1)
                              ]))
                            }), 128))
                          ])
                        ], 2))
                      }), 128))
                    ]))
            ]),
            _createVNode(_component_TableFooter, {
              onPageChange: fetchData,
              criteria: criteria.value
            }, null, 8, ["criteria"])
          ])
        ])
      ])
    ]),
    _createVNode(SalesRebateExportModal, {
      ref_key: "salesReportExportModalRef",
      ref: salesReportExportModalRef,
      onFetchData: fetchData
    }, null, 512),
    _createVNode(IbRebateExportModal, {
      ref_key: "ibReportExportModalRef",
      ref: ibReportExportModalRef,
      onFetchData: fetchData
    }, null, 512),
    _createVNode(CreateTypes, {
      ref_key: "createTypesRef",
      ref: createTypesRef
    }, null, 512),
    _createVNode(CreateReport, {
      ref_key: "createReportRef",
      ref: createReportRef,
      onFetchData: _cache[5] || (_cache[5] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})